import {createApp} from 'vue';
import i18n, {tl} from '@front/i18n';
import '@/style/tailwind.css';
import 'animate.css';
import '@/style/index.less';
import '@front/style/index.less';
import Components from '@/components';
import Directives from '@/directives';
import frontComponents, {setEnv} from './components';
import {errorHandler, setAxiosConfig, setStorage, Storage} from '@/services';
import App from './App.vue';
import router from './router';
import {setConfig, X_VERSION} from '@/glue';
import {useLanguage, useRouter} from '@front/hooks';
import BigNumber from 'bignumber.js';
import {initChannels, initContexts, pingChannel} from './api/utility';
import {checkBrowser} from '@/utils';
import {APPLE_ENV_CONTEXT} from '@front/constant';
import '@front/lib/appleid.auth';
import '@front/lib/apple_listener';

BigNumber.config({
  EXPONENTIAL_AT: 1e9, // Almost never return exponential notation
});

const API_PREFIX = '/api/front';

setConfig({
  DEFAULT_PORTAL: '/user/profile',
  X_VERSION: import.meta.env.X_VERSION,
  X_BRANCH_NAME: import.meta.env.X_BRANCH_NAME,
  API_PREFIX,
  pingChannel,
  i18n,
});

console.log('BUILD_TIME', import.meta.env.BUILD_TIME);

const app = createApp(App);
app.use(i18n);
app.use(Components);
app.use(Directives);

app.config.errorHandler = errorHandler;
app.config.productionTip = false;
app.config.globalProperties.$tl = tl('label');

const { setRouter } = useRouter();
const projectName = 'ccms_front';
setRouter(router);
const storage = new Storage({ prefix: projectName + '_' });
// const token = storage.get('token');
setConfig({ adminName: 'CCMS Front', projectName });
setStorage(storage);
// setAxiosConfig({ baseURL: API_PREFIX, headers: { 'x-version': X_VERSION, token } });
setAxiosConfig({ baseURL: API_PREFIX, headers: { 'x-version': X_VERSION } });
app.use(router);
app.use(frontComponents);

setEnv(import.meta.env.VITE_APP_ENV);

const { initLanguage, SYSTEM } = useLanguage();
initLanguage(SYSTEM.FRONT);
checkBrowser()
  .then(() => initChannels().catch(err => console.error('Init Channels Error', err)))
  .then(() => initContexts().catch(err => console.error('Init Contexts Error', err)))
  .then(() => app.mount('#app'))
  .catch(errorHandler);

AppleID.auth.init({
  clientId: APPLE_ENV_CONTEXT.CLIENT_ID[import.meta.env.VITE_APP_ENV],
  scope: 'name email',
  redirectURI: APPLE_ENV_CONTEXT.REDIRECT_URI[import.meta.env.VITE_APP_ENV],
  state: 'DE',
  nonce: 'nextop123',
  usePopup: true,
});
